var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5dcj8eyfka",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffa91d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fa631d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1213 -513) translate(1213 513)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    x: 0.5,
    y: 0.5,
    stroke: "url(#5dcj8eyfka)",
    rx: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#5dcj8eyfka)",
    fillRule: "nonzero",
    d: "M19.75 12.75H15.5c-.138 0-.25-.112-.25-.25V8.25C15.25 7.56 14.69 7 14 7s-1.25.56-1.25 1.25v4.25c0 .138-.112.25-.25.25H8.25C7.56 12.75 7 13.31 7 14s.56 1.25 1.25 1.25h4.25c.138 0 .25.112.25.25v4.25c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25V15.5c0-.138.112-.25.25-.25h4.25c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e090cbc73e1e9bb7b6bd17e5ae9409af.svg";
export { ForwardRef as ReactComponent };